export interface FormatNumberOptions {
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export const formatNumber = (locale: string) => (n: number | undefined, options?: FormatNumberOptions) => {
  return (n || 0).toLocaleString(locale, options);
};
